import React, { useState, useEffect, useRef, useCallback } from 'react';

import { useNavigate } from 'react-router-dom';
import sound from "../assets/sound.mp3";


function Particle({ x, y, size, color, velocityX, velocityY }) {

    return (

        <div

            style={{

                position: 'fixed',

                left: x,

                top: y,

                width: `${size}px`,

                height: `${size}px`,

                borderRadius: '50%',

                background: color,

                boxShadow: `0 0 ${size * 2}px ${size / 2}px ${color}`,

                pointerEvents: 'none',

                zIndex: 9999,

                mixBlendMode: 'screen',

                animation: 'particleLife 1s cubic-bezier(0.4, 0, 0.2, 1) forwards',

                '--vx': `${velocityX}px`,

                '--vy': `${velocityY}px`,

            }}

        />

    );

}



// ✅ Generates a soft luxury chime using Web Audio API — no file needed
let luxurySound;

function initSound() {
    luxurySound = new Audio(sound);
    luxurySound.volume = 0.4;
}

document.addEventListener("click", initSound, { once: true });

function playLuxuryChime() {

    if (!luxurySound) return;

    luxurySound.currentTime = 0;
    luxurySound.play();

    setTimeout(() => {
        luxurySound.pause();
        luxurySound.currentTime = 0;
    }, 1300);
}





export default function EntryPage() {

    const navigate = useNavigate();

    const [particles, setParticles] = useState([]);

    const [cursorPos, setCursorPos] = useState({ x: -100, y: -100 });

    const lastPosRef = useRef({ x: 0, y: 0 });

    const [transitionState, setTransitionState] = useState('idle');



    const handleNavigate = () => {

        if (transitionState !== 'idle') return;



        // ✅ Play chime on click — browsers allow audio after user gesture

        playLuxuryChime();



        setTransitionState('zooming');

        setTimeout(() => navigate('/home'), 900);

    };



    const handleMouseMove = useCallback((e) => {

        const { clientX: x, clientY: y } = e;

        setCursorPos({ x, y });



        const dx = x - lastPosRef.current.x;

        const dy = y - lastPosRef.current.y;

        const distance = Math.sqrt(dx * dx + dy * dy);



        if (distance > 10) {

            const id = Date.now();

            const newParticle = {

                id, x, y,

                size: Math.random() * 4 + 2,

                velocityX: (Math.random() - 0.5) * 40,

                velocityY: (Math.random() - 0.5) * 40 + 20,

                color: Math.random() > 0.5 ? '#FFD700' : '#FFFACD',

            };



            setParticles((prev) => [...prev.slice(-25), newParticle]);

            lastPosRef.current = { x, y };



            setTimeout(() => {

                setParticles((prev) => prev.filter((p) => p.id !== id));

            }, 1000);

        }

    }, []);



    useEffect(() => {

        window.addEventListener('mousemove', handleMouseMove);

        return () => window.removeEventListener('mousemove', handleMouseMove);

    }, [handleMouseMove]);



    return (

        <>

            <style>{`

                @keyframes particleLife {

                    0%   { opacity: 1; transform: translate(-50%, -50%) translate(0, 0) scale(1); }

                    100% { opacity: 0; transform: translate(-50%, -50%) translate(var(--vx), var(--vy)) scale(0); }

                }



                @keyframes zoomIntoScreen {

                    0%   { opacity: 1; transform: scale(1);    filter: blur(0px); }

                    60%  { opacity: 1; transform: scale(1.08); filter: blur(2px); }

                    100% { opacity: 0; transform: scale(1.6);  filter: blur(12px); }

                }



                .page-zoom-exit {

                    animation: zoomIntoScreen 0.9s cubic-bezier(0.4, 0, 1, 1) forwards;

                }



                * { cursor: none !important; }

            `}</style>



            {/* Particle trail */}

            {particles.map((p) => (

                <Particle key={p.id} {...p} />

            ))}



            {/* Cursor core */}

            <div style={{

                position: 'fixed', left: cursorPos.x, top: cursorPos.y,

                width: '8px', height: '8px',

                background: '#FFF', borderRadius: '50%',

                transform: 'translate(-50%, -50%)',

                boxShadow: '0 0 15px 2px #FFD700',

                zIndex: 10000, pointerEvents: 'none',

                transition: 'transform 0.1s ease-out',

            }} />



            {/* Lagging outer ring */}

            <div style={{

                position: 'fixed', left: cursorPos.x, top: cursorPos.y,

                width: '40px', height: '40px',

                border: '1px solid rgba(212, 175, 55, 0.3)',

                borderRadius: '50%',

                transform: 'translate(-50%, -50%)',

                zIndex: 9998, pointerEvents: 'none',

                transition: 'left 0.15s cubic-bezier(0.19, 1, 0.22, 1), top 0.15s cubic-bezier(0.19, 1, 0.22, 1)',

            }} />



            {/* Page */}

            <div

                onClick={handleNavigate}

                className={`relative h-screen w-full flex flex-col items-center justify-center overflow-hidden bg-black ${transitionState === 'zooming' ? 'page-zoom-exit' : ''

                    }`}

            >

                <div className="absolute inset-0 z-0">

                    <video autoPlay loop muted playsInline className="w-full h-full object-cover opacity-40">

                        <source src="/115430-704729739_medium.mp4" type="video/mp4" />

                    </video>

                    <div className="absolute inset-0 bg-black/40" />

                </div>



                <div className="text-center z-10 select-none">

                    <h1 className="font-display text-white text-6xl md:text-8xl tracking-[0.2em] mb-4 transition-all hover:tracking-[0.25em] duration-700">

                        AURÉNE

                    </h1>

                    <p className="text-[#D4AF37] font-light tracking-[0.8em] uppercase text-[10px] opacity-70 animate-pulse">

                        Click anywhere to enter the atelier

                    </p>

                </div>

            </div>

        </>

    );

}